import { apiGet, apiPatch } from '@/lib/http/client';

import type { PipelineStageMappingsResponse } from '../types';

export interface UpdatePipelineStageMappingBody {
  ahoy_stage_entity_id: string;
  hubspot_stage_id: string;
}

export async function getPipelineStageMappings(
  orgId: number | string
): Promise<PipelineStageMappingsResponse> {
  return apiGet<PipelineStageMappingsResponse>(
    `/api/orgs/${orgId}/hubspot/pipeline-stage-mappings/`
  );
}

export async function updatePipelineStageMapping(
  orgId: number | string,
  body: UpdatePipelineStageMappingBody
): Promise<void> {
  await apiPatch<unknown>(
    `/api/orgs/${orgId}/hubspot/pipeline-stage-mappings/update/`,
    body
  );
}
